import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/client/react";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { ConfigProvider } from "antd";

import config from "./config";

import "./index.scss";

import App from "./App";
import store from "./store";
import apolloClient from "./graphql";

import * as serviceWorker from "./serviceWorker";

Sentry.init({
  environment: config.NODE_ENV,
  dsn: config.SENTRY_URL,
  integrations: [new Integrations.BrowserTracing()],
  release: config.SENTRY_RELEASE,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <BrowserRouter>
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <ConfigProvider
          theme={{
            token: {
              // Seed Token
              colorPrimary: "#555",
              borderRadius: 4,

              // Alias Token
              // colorBgContainer: "#f6ffed",
            },
            // components: {
            //   Card: {
            //     padding: "0",
            //   },
            // },
          }}
        >
          <Sentry.ErrorBoundary fallback={"An error has occurred"}>
            <App />
          </Sentry.ErrorBoundary>
        </ConfigProvider>
      </Provider>
    </ApolloProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
